import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "./AuthShell";
import { api } from "@/lib/api";
import { AUTH } from "@/constants/testIds";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Missing reset token");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset. Please sign in.");
      nav("/login", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally { setSubmitting(false); }
  };

  return (
    <AuthShell title="Set a new password" subtitle="Choose a strong password of at least 8 characters">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-xs font-semibold text-gray-700 mb-1.5">New password</label>
          <input
            data-testid={AUTH.resetPassword} type="password" required minLength={8}
            value={pw} onChange={(e) => setPw(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#EAF4E3] focus:border-[#538135]"
          />
        </div>
        <button
          data-testid={AUTH.resetSubmit}
          disabled={submitting || pw.length < 8}
          className="w-full bg-[#538135] text-white hover:bg-[#09582D] rounded-md px-4 py-3 text-sm font-semibold disabled:opacity-60"
        >
          {submitting ? "Updating…" : "Update password"}
        </button>
        <Link to="/login" className="block text-center text-sm text-gray-600 hover:text-gray-900">
          Back to sign in
        </Link>
      </form>
    </AuthShell>
  );
}
